// ISO 3166-1 alpha-2
export const countryCodes = [
  { value: 'AD', displayValue: 'Andorra' },
  { value: 'AE', displayValue: 'United Arab Emirates' },
  { value: 'AF', displayValue: 'Afghanistan' },
  { value: 'AG', displayValue: 'Antigua & Barbuda' },
  { value: 'AI', displayValue: 'Anguilla' },
  { value: 'AL', displayValue: 'Albania' },
  { value: 'AM', displayValue: 'Armenia' },
  { value: 'AO', displayValue: 'Angola' },
  { value: 'AQ', displayValue: 'Antarctica' },
  { value: 'AR', displayValue: 'Argentina' },
  { value: 'AS', displayValue: 'American Samoa' },
  { value: 'AT', displayValue: 'Austria' },
  { value: 'AU', displayValue: 'Australia' },
  { value: 'AW', displayValue: 'Aruba' },
  { value: 'AX', displayValue: 'Åland Islands' },
  { value: 'AZ', displayValue: 'Azerbaijan' },
  { value: 'BA', displayValue: 'Bosnia' },
  { value: 'BB', displayValue: 'Barbados' },
  { value: 'BD', displayValue: 'Bangladesh' },
  { value: 'BE', displayValue: 'Belgium' },
  { value: 'BF', displayValue: 'Burkina Faso' },
  { value: 'BG', displayValue: 'Bulgaria' },
  { value: 'BH', displayValue: 'Bahrain' },
  { value: 'BI', displayValue: 'Burundi' },
  { value: 'BJ', displayValue: 'Benin' },
  { value: 'BL', displayValue: 'St. Barthélemy' },
  { value: 'BM', displayValue: 'Bermuda' },
  { value: 'BN', displayValue: 'Brunei' },
  { value: 'BO', displayValue: 'Bolivia' },
  { value: 'BQ', displayValue: 'Caribbean Netherlands' },
  { value: 'BR', displayValue: 'Brazil' },
  { value: 'BS', displayValue: 'Bahamas' },
  { value: 'BT', displayValue: 'Bhutan' },
  { value: 'BW', displayValue: 'Botswana' },
  { value: 'BY', displayValue: 'Belarus' },
  { value: 'BZ', displayValue: 'Belize' },
  { value: 'CA', displayValue: 'Canada' },
  { value: 'CC', displayValue: 'Cocos (Keeling) Islands' },
  { value: 'CD', displayValue: 'Congo (DRC)' },
  { value: 'CF', displayValue: 'Central African Republic' },
  { value: 'CG', displayValue: 'Congo (Republic)' },
  { value: 'CH', displayValue: 'Switzerland' },
  { value: 'CI', displayValue: 'Ivory Coast' },
  { value: 'CK', displayValue: 'Cook Islands' },
  { value: 'CL', displayValue: 'Chile' },
  { value: 'CM', displayValue: 'Cameroon' },
  { value: 'CN', displayValue: 'China' },
  { value: 'CO', displayValue: 'Colombia' },
  { value: 'CR', displayValue: 'Costa Rica' },
  { value: 'CU', displayValue: 'Cuba' },
  { value: 'CV', displayValue: 'Cabo Verde' },
  { value: 'CW', displayValue: 'Curaçao' },
  { value: 'CX', displayValue: 'Christmas Island' },
  { value: 'CY', displayValue: 'Cyprus' },
  { value: 'CZ', displayValue: 'Czechia' },
  { value: 'DE', displayValue: 'Germany' },
  { value: 'DJ', displayValue: 'Djibouti' },
  { value: 'DK', displayValue: 'Denmark' },
  { value: 'DM', displayValue: 'Dominica' },
  { value: 'DO', displayValue: 'Dominican Republic' },
  { value: 'DZ', displayValue: 'Algeria' },
  { value: 'EC', displayValue: 'Ecuador' },
  { value: 'EE', displayValue: 'Estonia' },
  { value: 'EG', displayValue: 'Egypt' },
  { value: 'EH', displayValue: 'Western Sahara' },
  { value: 'ER', displayValue: 'Eritrea' },
  { value: 'ES', displayValue: 'Spain' },
  { value: 'ET', displayValue: 'Ethiopia' },
  { value: 'FI', displayValue: 'Finland' },
  { value: 'FJ', displayValue: 'Fiji' },
  { value: 'FK', displayValue: 'Falkland Islands (Islas Malvinas)' },
  { value: 'FM', displayValue: 'Micronesia' },
  { value: 'FO', displayValue: 'Faroe Islands' },
  { value: 'FR', displayValue: 'France' },
  { value: 'GA', displayValue: 'Gabon' },
  { value: 'GB', displayValue: 'United Kingdom' },
  { value: 'GD', displayValue: 'Grenada' },
  { value: 'GE', displayValue: 'Georgia' },
  { value: 'GF', displayValue: 'French Guiana' },
  { value: 'GG', displayValue: 'Guernsey' },
  { value: 'GH', displayValue: 'Ghana' },
  { value: 'GI', displayValue: 'Gibraltar' },
  { value: 'GL', displayValue: 'Greenland' },
  { value: 'GM', displayValue: 'Gambia' },
  { value: 'GN', displayValue: 'Guinea' },
  { value: 'GP', displayValue: 'Guadeloupe' },
  { value: 'GQ', displayValue: 'Equatorial Guinea' },
  { value: 'GR', displayValue: 'Greece' },
  { value: 'GS', displayValue: 'South Georgia & South Sandwich Islands' },
  { value: 'GT', displayValue: 'Guatemala' },
  { value: 'GU', displayValue: 'Guam' },
  { value: 'GW', displayValue: 'Guinea-Bissau' },
  { value: 'GY', displayValue: 'Guyana' },
  { value: 'HK', displayValue: 'Hong Kong' },
  { value: 'HN', displayValue: 'Honduras' },
  { value: 'HR', displayValue: 'Croatia' },
  { value: 'HT', displayValue: 'Haiti' },
  { value: 'HU', displayValue: 'Hungary' },
  { value: 'ID', displayValue: 'Indonesia' },
  { value: 'IE', displayValue: 'Ireland' },
  { value: 'IL', displayValue: 'Israel' },
  { value: 'IM', displayValue: 'Isle of Man' },
  { value: 'IN', displayValue: 'India' },
  { value: 'IO', displayValue: 'British Indian Ocean Territory' },
  { value: 'IQ', displayValue: 'Iraq' },
  { value: 'IR', displayValue: 'Iran' },
  { value: 'IS', displayValue: 'Iceland' },
  { value: 'IT', displayValue: 'Italy' },
  { value: 'JE', displayValue: 'Jersey' },
  { value: 'JM', displayValue: 'Jamaica' },
  { value: 'JO', displayValue: 'Jordan' },
  { value: 'JP', displayValue: 'Japan' },
  { value: 'KE', displayValue: 'Kenya' },
  { value: 'KG', displayValue: 'Kyrgyzstan' },
  { value: 'KH', displayValue: 'Cambodia' },
  { value: 'KI', displayValue: 'Kiribati' },
  { value: 'KM', displayValue: 'Comoros' },
  { value: 'KN', displayValue: 'St. Kitts & Nevis' },
  { value: 'KP', displayValue: 'North Korea' },
  { value: 'KR', displayValue: 'South Korea' },
  { value: 'KW', displayValue: 'Kuwait' },
  { value: 'KY', displayValue: 'Cayman Islands' },
  { value: 'KZ', displayValue: 'Kazakhstan' },
  { value: 'LA', displayValue: 'Laos' },
  { value: 'LB', displayValue: 'Lebanon' },
  { value: 'LC', displayValue: 'St. Lucia' },
  { value: 'LI', displayValue: 'Liechtenstein' },
  { value: 'LK', displayValue: 'Sri Lanka' },
  { value: 'LR', displayValue: 'Liberia' },
  { value: 'LS', displayValue: 'Lesotho' },
  { value: 'LT', displayValue: 'Lithuania' },
  { value: 'LU', displayValue: 'Luxembourg' },
  { value: 'LV', displayValue: 'Latvia' },
  { value: 'LY', displayValue: 'Libya' },
  { value: 'MA', displayValue: 'Morocco' },
  { value: 'MC', displayValue: 'Monaco' },
  { value: 'MD', displayValue: 'Moldova' },
  { value: 'ME', displayValue: 'Montenegro' },
  { value: 'MF', displayValue: 'St. Martin' },
  { value: 'MG', displayValue: 'Madagascar' },
  { value: 'MH', displayValue: 'Marshall Islands' },
  { value: 'MK', displayValue: 'North Macedonia' },
  { value: 'ML', displayValue: 'Mali' },
  { value: 'MM', displayValue: 'Myanmar' },
  { value: 'MN', displayValue: 'Mongolia' },
  { value: 'MO', displayValue: 'Macao' },
  { value: 'MP', displayValue: 'Northern Mariana Islands' },
  { value: 'MQ', displayValue: 'Martinique' },
  { value: 'MR', displayValue: 'Mauritania' },
  { value: 'MS', displayValue: 'Montserrat' },
  { value: 'MT', displayValue: 'Malta' },
  { value: 'MU', displayValue: 'Mauritius' },
  { value: 'MV', displayValue: 'Maldives' },
  { value: 'MW', displayValue: 'Malawi' },
  { value: 'MX', displayValue: 'Mexico' },
  { value: 'MY', displayValue: 'Malaysia' },
  { value: 'MZ', displayValue: 'Mozambique' },
  { value: 'NA', displayValue: 'Namibia' },
  { value: 'NC', displayValue: 'New Caledonia' },
  { value: 'NE', displayValue: 'Niger' },
  { value: 'NF', displayValue: 'Norfolk Island' },
  { value: 'NG', displayValue: 'Nigeria' },
  { value: 'NI', displayValue: 'Nicaragua' },
  { value: 'NL', displayValue: 'Netherlands' },
  { value: 'NO', displayValue: 'Norway' },
  { value: 'NP', displayValue: 'Nepal' },
  { value: 'NR', displayValue: 'Nauru' },
  { value: 'NU', displayValue: 'Niue' },
  { value: 'NZ', displayValue: 'Aotearoa New Zealand' },
  { value: 'OM', displayValue: 'Oman' },
  { value: 'PA', displayValue: 'Panama' },
  { value: 'PE', displayValue: 'Peru' },
  { value: 'PF', displayValue: 'French Polynesia' },
  { value: 'PG', displayValue: 'Papua New Guinea' },
  { value: 'PH', displayValue: 'Philippines' },
  { value: 'PK', displayValue: 'Pakistan' },
  { value: 'PL', displayValue: 'Poland' },
  { value: 'PM', displayValue: 'St. Pierre & Miquelon' },
  { value: 'PN', displayValue: 'Pitcairn Islands' },
  { value: 'PR', displayValue: 'Puerto Rico' },
  { value: 'PS', displayValue: 'Palestine' },
  { value: 'PT', displayValue: 'Portugal' },
  { value: 'PW', displayValue: 'Palau' },
  { value: 'PY', displayValue: 'Paraguay' },
  { value: 'QA', displayValue: 'Qatar' },
  { value: 'RE', displayValue: 'Réunion' },
  { value: 'RO', displayValue: 'Romania' },
  { value: 'RS', displayValue: 'Serbia' },
  { value: 'RU', displayValue: 'Russia' },
  { value: 'RW', displayValue: 'Rwanda' },
  { value: 'SA', displayValue: 'Saudi Arabia' },
  { value: 'SB', displayValue: 'Solomon Islands' },
  { value: 'SC', displayValue: 'Seychelles' },
  { value: 'SD', displayValue: 'Sudan' },
  { value: 'SE', displayValue: 'Sweden' },
  { value: 'SG', displayValue: 'Singapore' },
  { value: 'SH', displayValue: 'St. Helena' },
  { value: 'SI', displayValue: 'Slovenia' },
  { value: 'SJ', displayValue: 'Svalbard & Jan Mayen' },
  { value: 'SK', displayValue: 'Slovakia' },
  { value: 'SL', displayValue: 'Sierra Leone' },
  { value: 'SM', displayValue: 'San Marino' },
  { value: 'SN', displayValue: 'Senegal' },
  { value: 'SO', displayValue: 'Somalia' },
  { value: 'SR', displayValue: 'Suriname' },
  { value: 'SS', displayValue: 'South Sudan' },
  { value: 'ST', displayValue: 'São Tomé & Príncipe' },
  { value: 'SV', displayValue: 'El Salvador' },
  { value: 'SX', displayValue: 'Sint Maarten' },
  { value: 'SY', displayValue: 'Syria' },
  { value: 'SZ', displayValue: 'Swaziland' },
  { value: 'TC', displayValue: 'Turks & Caicos Islands' },
  { value: 'TD', displayValue: 'Chad' },
  { value: 'TF', displayValue: 'French Southern Territories' },
  { value: 'TG', displayValue: 'Togo' },
  { value: 'TH', displayValue: 'Thailand' },
  { value: 'TJ', displayValue: 'Tajikistan' },
  { value: 'TK', displayValue: 'Tokelau' },
  { value: 'TL', displayValue: 'East Timor' },
  { value: 'TM', displayValue: 'Turkmenistan' },
  { value: 'TN', displayValue: 'Tunisia' },
  { value: 'TO', displayValue: 'Tonga' },
  { value: 'TR', displayValue: 'Türkiye' },
  { value: 'TT', displayValue: 'Trinidad & Tobago' },
  { value: 'TV', displayValue: 'Tuvalu' },
  { value: 'TW', displayValue: 'Taiwan' },
  { value: 'TZ', displayValue: 'Tanzania' },
  { value: 'UA', displayValue: 'Ukraine' },
  { value: 'UG', displayValue: 'Uganda' },
  { value: 'UM', displayValue: 'U.S. Outlying Islands' },
  { value: 'US', displayValue: 'United States' },
  { value: 'UY', displayValue: 'Uruguay' },
  { value: 'UZ', displayValue: 'Uzbekistan' },
  { value: 'VA', displayValue: 'Vatican City' },
  { value: 'VC', displayValue: 'St. Vincent & Grenadines' },
  { value: 'VE', displayValue: 'Venezuela' },
  { value: 'VG', displayValue: 'British Virgin Islands' },
  { value: 'VI', displayValue: 'U.S. Virgin Islands' },
  { value: 'VN', displayValue: 'Vietnam' },
  { value: 'VU', displayValue: 'Vanuatu' },
  { value: 'WF', displayValue: 'Wallis & Futuna' },
  { value: 'WS', displayValue: 'Samoa' },
  { value: 'XK', displayValue: 'Kosovo' },
  { value: 'YE', displayValue: 'Yemen' },
  { value: 'YT', displayValue: 'Mayotte' },
  { value: 'ZA', displayValue: 'South Africa' },
  { value: 'ZM', displayValue: 'Zambia' },
  { value: 'ZW', displayValue: 'Zimbabwe' },
].sort((a, b) => a.displayValue.localeCompare(b.displayValue));

export const states = [
  { value: 'AL', label: 'Alabama' },
  { value: 'AK', label: 'Alaska' },
  { value: 'AZ', label: 'Arizona' },
  { value: 'AR', label: 'Arkansas' },
  { value: 'CA', label: 'California' },
  { value: 'CO', label: 'Colorado' },
  { value: 'CT', label: 'Connecticut' },
  { value: 'DE', label: 'Delaware' },
  { value: 'DC', label: 'District Of Columbia' },
  { value: 'FL', label: 'Florida' },
  { value: 'GA', label: 'Georgia' },
  { value: 'HI', label: 'Hawaii' },
  { value: 'ID', label: 'Idaho' },
  { value: 'IL', label: 'Illinois' },
  { value: 'IN', label: 'Indiana' },
  { value: 'IA', label: 'Iowa' },
  { value: 'KS', label: 'Kansas' },
  { value: 'KY', label: 'Kentucky' },
  { value: 'LA', label: 'Louisiana' },
  { value: 'ME', label: 'Maine' },
  { value: 'MD', label: 'Maryland' },
  { value: 'MA', label: 'Massachusetts' },
  { value: 'MI', label: 'Michigan' },
  { value: 'MN', label: 'Minnesota' },
  { value: 'MS', label: 'Mississippi' },
  { value: 'MO', label: 'Missouri' },
  { value: 'MT', label: 'Montana' },
  { value: 'NE', label: 'Nebraska' },
  { value: 'NV', label: 'Nevada' },
  { value: 'NH', label: 'New Hampshire' },
  { value: 'NJ', label: 'New Jersey' },
  { value: 'NM', label: 'New Mexico' },
  { value: 'NY', label: 'New York' },
  { value: 'NC', label: 'North Carolina' },
  { value: 'ND', label: 'North Dakota' },
  { value: 'OH', label: 'Ohio' },
  { value: 'OK', label: 'Oklahoma' },
  { value: 'OR', label: 'Oregon' },
  { value: 'PA', label: 'Pennsylvania' },
  { value: 'RI', label: 'Rhode Island' },
  { value: 'SC', label: 'South Carolina' },
  { value: 'SD', label: 'South Dakota' },
  { value: 'TN', label: 'Tennessee' },
  { value: 'TX', label: 'Texas' },
  { value: 'UT', label: 'Utah' },
  { value: 'VT', label: 'Vermont' },
  { value: 'VA', label: 'Virginia' },
  { value: 'WA', label: 'Washington' },
  { value: 'WV', label: 'West Virginia' },
  { value: 'WI', label: 'Wisconsin' },
  { value: 'WY', label: 'Wyoming' },
];
